var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconShop = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M14.25 10.5C14.25 11.7426 13.2426 12.75 12 12.75C10.7574 12.75 9.75 11.7426 9.75 10.5C9.75 10.0858 9.41421 9.75 9 9.75C8.58579 9.75 8.25 10.0858 8.25 10.5C8.25 12.5711 9.92893 14.25 12 14.25C14.0711 14.25 15.75 12.5711 15.75 10.5C15.75 10.0858 15.4142 9.75 15 9.75C14.5858 9.75 14.25 10.0858 14.25 10.5Z", fill: "#192325" }),
            React.createElement("path", { d: "M8.25 6V6.75H6C4.34315 6.75 3 8.09315 3 9.75V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V9.75C21 8.09315 19.6569 6.75 18 6.75H15.75V6C15.75 3.92893 14.0711 2.25 12 2.25C9.92893 2.25 8.25 3.92893 8.25 6ZM12 3.75C13.2426 3.75 14.25 4.75736 14.25 6V6.75H9.75V6C9.75 4.75736 10.7574 3.75 12 3.75ZM6 8.25H18C18.8284 8.25 19.5 8.92157 19.5 9.75V18C19.5 18.8284 18.8284 19.5 18 19.5H6C5.17157 19.5 4.5 18.8284 4.5 18V9.75C4.5 8.92157 5.17157 8.25 6 8.25Z", fill: "#192325" }))),
        alt: 'Icon Shop',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconShop;
//# sourceMappingURL=index.js.map